/*
* 组织机构树工具
* 创建时间：2017/11/2
* 创建人：DrugsZ
*/
<template>
	<div>
		<!-- <p v-show="isEmty" class="cus_message form-group__message">没有匹配结果"{{errorVal}}"</p>-->
		<input type="text" :id="'input_'+randomNumber" class="form-control menuInput" v-model="queryGroup" @focus="showMenu" autocomplete="off" disableautocomplete>
		<div :id="'content_'+randomNumber" class="menuContent" style="display:none; position: absolute;">
			<ul v-show="!isEmty" :id="'tree_'+randomNumber" class="ztree ztree-slide" style="margin-top:0; width:100%; max-height:300px; height:auto !important; box-sizing:border-box;"></ul>
			<p v-show="isEmty">没有匹配结果 "{{errorVal}}"</p>
		</div>	
	</div>
</template>

<script>
	import 'assets/plugins/ztree/css/metroStyle/metroStyle.css'
	import 'assets/plugins/ztree/js/jquery.ztree.core.js'
	import 'assets/plugins/ztree/js/jquery.ztree.excheck.js'
	import 'assets/plugins/ztree/js/jquery.ztree.exedit.js'
	import { queryTree } from 'util/util'
	
export default{
	name:'CustomerTree',
	data(){
		return {
			randomNumber:'',
			treeObj:{},
			queryGroup:'',
			groupList:[],
			isEmty:false,
			mounted:false,
			errorVal:''
		}
	},
	props:{ 
		//是否立即加载
		isTreeInit:{
			type:Boolean,
			default:true
		},
		//是否可以点击根节点
		isRootNode:{
			type:Boolean,
			default:false
		},
		//是否默认显示根节点
		isShowOrganize:{
			type:Boolean,
			default:false
		},
		//是否隐藏某项id
		isHiddenId:{
			type:String,
			default:''
		},
		//zTree相关配置项
		setting:{
			type:Object,
			required:true
		},
		value:{
			required:true
		},
		//请求地址
		url:{
			required:true
		},
		//请求方法，默认为GET
		method:{
			type:String,
			default:'get'
		},
		//是否开启模糊查询
		search:{
			type:Boolean,
			default:true
		},
		//请求携带参数
		para:{
			type:Object,
			default(){
				return {}
			}
		},
		//是否默认展开
		expandAll:{
			type:Boolean,
			default:true
		}
	},
	created(){ 
		//获取毫秒，保持ID唯一性
		this.randomNumber =new Date().getTime()
	},
	mounted(){
		//设置配置项，如未配置，采用默认值
		this.setting.data.simpleData = this.setting.data.simpleData || {}
		this.setting.data.key = this.setting.data.key || {}
	},
	watch:{
		//模糊查询与值变动相关
		value(val){
			if(val==''){
				this.queryGroup = '' 
				return;
			}
			let _id = this.setting.data.simpleData.idKey||'id';
			let _name = this.setting.data.key.name || 'name'
			let self = this;
			this.groupList.map(item=>{
				if(item[_id] == self.value){
					self.queryGroup = item[_name]
				}
			})
		},
		queryGroup(val){
			if(!this.search){
				return;
			}
			let name = this.setting.data.key.name || 'name'
			if(val){
				let nodeList = queryTree(this.treeObj,val,name)
				if(nodeList.length == 0){
					this.isEmty = true
					this.errorVal = val
					this.setting.data.simpleData.enable = true;
				}else{
					this.setting.data.simpleData.enable = false; 
					this.isEmty = false
				}  
				//判断渠道是否正确
				for(var i = 0; i < this.groupList.length; i++) {
			        let ownerType = this.groupList.findIndex(n=>n[name]==val)
			        if(ownerType == "-1"){
			        	this.$emit('channelError',{name:val,channelError:false})
			        }else{
			        	let id = this.groupList[ownerType][this.setting.data.simpleData.idKey]||this.groupList[ownerType].id;
			        	this.$emit('input',id)
			        	this.$emit('channelError',{name:val,channelError:true})
			        }
				}
				$.fn.zTree.getZTreeObj('tree_'+this.randomNumber).expandAll(false) 
				$.fn.zTree.init($('#tree_'+this.randomNumber),this.setting,nodeList) 
			}else{
				this.isEmty = false
				this.$emit('input','')
				//渠道为空时触发
				this.$emit('channelError',{name:"",channelError:false})
				this.setting.data.simpleData.enable = true;
				$.fn.zTree.init($('#tree_'+this.randomNumber), this.setting, this.groupList); 
			}
		}
	},
	beforeMount(){
		if(this.isTreeInit){
			this.getTree()
		} 
		//设置配置项，如未配置，采用默认值
		if(this.setting.callback){
			this.setting.callback.onClick = this.setting.callback.onClick||this.onClick
		}else{
			this.setting.callback = {};
			this.setting.callback.onClick = this.onClick
		}
		
	},
	methods:{
		//显示、隐藏下拉树
			showMenu(){
				$("#content_"+this.randomNumber).slideDown("fast");
				$("body").bind("mousedown", this.onBodyDown);
			},
			onBodyDown(event){
				if (!(event.target.id == 'input_'+this.randomNumber || event.target.id == 'content_'+this.randomNumber || $(event.target).parents(".menuContent").length>0)) {
					this.hideMenu();
				}
			},
			hideMenu() {
				$("#content_"+this.randomNumber).fadeOut("fast");
				$("body").unbind("mousedown", this.onBodyDown);
			},
			//z-tree 相关
			treeInit(){//初始化z-tree树
				$.fn.zTree.init($('#tree_'+this.randomNumber), this.setting, this.groupList); 
				this.$nextTick(() => {
					let obj = $.fn.zTree.getZTreeObj('tree_'+this.randomNumber)
					this.treeObj = obj.transformToArray(obj.getNodes())
					//是否显示默认根节点
					if(this.isShowOrganize){
						let treeObj = $.fn.zTree.getZTreeObj('tree_'+this.randomNumber);
					    //返回一个根节点
						let nodes = treeObj.getNodesByFilter(function (node) { return node.level == 0 }, true);
						let id = nodes[this.setting.data.simpleData.idKey]||nodes.id;
						this.$emit('input',id)
					}
					this.$emit('onsuccess')//加载成功回调
				})
			},
			onClick(e,treeId,treeNode){//点击树节点
				let id = treeNode[this.setting.data.simpleData.idKey]||treeNode.id;
				//根节点是否可点击
				
				if(this.isRootNode){
					if(id ==1){
						return;
					}
				} 
				this.$emit('input',id)
				this.hideMenu()
				
			},
			//拉取数据
			getTree(){ 
				this.$http[this.method](process.env.API_ROOT+this.url,{params:this.para})
				.then(res=>{
					if(res.body.success){
						let resInfo = res.body.data;
						//判断是否隐藏某节点
						if(this.isHiddenId){
							let name = this.setting.data.key.name || 'name'
							for(var i = 0; i < resInfo.length; i++) {
								if(this.isHiddenId == resInfo[i][name]){
									 resInfo.splice(i, 1);
								}
							}
						}
						this.groupList = resInfo;
						this.groupList.map(item=>{
							item.open=true;
							return item;
						})
						this.$emit('onsuccessdata',this.groupList)
						this.treeInit()
					}else{
						this.$emit('onerror',res.body.message)
					}
				},res=>{
					this.$emit('onerror',res.body.message)
				}).catch(res=>{
					this.$emit('onerror','请求异常')//加载失败回调
				})
			},
			reSet(){
				this.queryGroup ='';
				this.$emit('input','');
			}
	}
}
</script>

<style scoped>
.menuInput {
		position: relative;
	}
	
	.menuContent {
		position: absolute;
		top: 31px;
		left: 6px;
		border: 1px solid #ddd;
		z-index: 999;
		width:calc(100% - 10px);
		box-shadow:5px 5px 5px #ddd;
	}
	
	.menuContent p{
		padding-left:5px;
		background-color:#eee;
		margin-bottom:0; 
	}
</style>


// WEBPACK FOOTER //
// CustomerTree.vue?139c99ec